import React, { Component } from "react";
import { leadType } from "../../../../app";
import commonContext, { AppContext } from "../../../context/common";

export class IAgreeTermsInsurence extends Component<{
    onclickhandler?: Function;
    onclickhandlerCancel?: Function;
    history?: any;
}> {
    static contextType = commonContext;
    lead: leadType;
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                <div className="container my-5 mx-auto px-2 md:px-5">
                    {this.lead.insuranceAvailed ? (
                        <>
                            <h2 className="openSans-Reg text-black mt-3 my-6 md:mt-5 md:my-8 text-2xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Acceptance of Sarv Suraksha Insurance Terms and
                                Conditions
                            </h2>
                            <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-8">
                                • I accept the Terms and Conditions of the
                                insurance policy.
                                <br />• I/We hereby declare on my behalf and on
                                behalf of all persons proposed to be insured
                                that the above statements are true and complete
                                in all respects to the best of my knowledge and
                                that I/We am/are authorized to propose on behalf
                                of these other persons. <br />• I understand
                                that the information provided by me will form
                                the basis of insurance policy, is subject to the
                                Board approved underwriting policy of the
                                Insurance company and that the policy will come
                                into force only after full receipt of the
                                premium chargeable <br />• I/We further declare
                                that I/We will notify in writing any change
                                occurring in the occupation or general health of
                                the life to be insured/ proposer after the
                                proposal has been submitted but before
                                communication of the risk acceptance by the
                                company. <br />• I/we declare and further
                                consent to the company. seeking medical
                                information from any doctor or from a hospital
                                who at anytime has attended on the life to be
                                insured/ proposer or from any past or present
                                employer concerning anything which affects the
                                physical and mental health of the life to be
                                assured/proposer and seeking information from
                                any insurance company to which an application
                                for insurance on the life to be assured/
                                proposer has been made for the purpose of
                                underwriting the proposal and/or claim
                                settlement. <br />• I/We authorize the company
                                to share information pertaining to my proposal
                                including the medical records for the sole
                                purpose of proposal underwriting and/or claims
                                settlement and with any Governmental and/or
                                Regulatory Authority. <br />• I authorize HDFC
                                ERGO General Insurance and associate partners to
                                contact me via email, phone, SMS. <br />• I/We
                                hereby declare that I/We not engaged in military
                                service, police, professional sports, mine
                                workers, fire workers, fire fighters, water
                                vessel crew, oil field/oil rig workers,
                                structural workers, window cleaners,
                                junk/salvage workers, saw mill workers, security
                                guards and similar hazardous occupations or
                                professionals like doctors, Lawyers and
                                politically exposed personal It is essential
                                that you answer fully and accurately all the
                                question contained in this proposal, and that
                                you provide us with any and all condition
                                information relevant to the risk to be insured
                                or our decision as to the acceptance of the risk
                                or the term upon which it should be accepted.
                                Your failure to comply with this obligation now
                                may result in the rejection of your claim and
                                the avoidance of your policy when a claim is
                                made. If you are in any doubt about the
                                information to be given, please seek the advice
                                of your insurance advisor. The liability of HDFC
                                ERGO General Insurance Company Ltd DOES NOT
                                commence until THE Company has accepted the
                                proposal and the full premium has been paid.
                                Participation by Financier’s customer shall be
                                purely on voluntary. The contract of insurance
                                is between HDFC ERGO General Insurance Company
                                Ltd. and the insured and not between Financier
                                and the Financier shall not warranty / guarantee
                                or be liable for the services provided by HDFC
                                ERGO General Insurance Company Ltd. Financier
                                shall not take responsibility for settlement of
                                claims and HDFC ERGO’s decisions in this regard
                                shall be final. Any grievance with respect to
                                insurance policy/ claims/ settlement shall be
                                taken up with HDFC ERGO General Insurance
                                Company Ltd. and Financier shall not be
                                responsible/ liable for the same. Customers are
                                requested to read the offer document before
                                taking the insurance. It is at your will to buy
                                Sarv Suraksha Pro/Motor Insurance offered by
                                HDFC ERGO. You are at liberty to choose your own
                                insurer for your insurance need.
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    {this.lead.motorInsuranceAvailed ? (
                        <>
                            <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                <h2 className="openSans-Reg text-black mt-3 my-6 md:mt-5 md:my-8 text-2xl md:text-3xl lg:text-3xl xl:text-4xl">
                                    Acceptance of Motor Insurance Terms and
                                    Conditions{" "}
                                </h2>
                                • Dear Customer, kindly note: <br />• Policy is
                                issued based on the risk details , coverage, NCB
                                declaration and appropriate disclosure of
                                factual statements made by me and basis policy
                                details which has been explained to me. In case
                                of false declaration the covers stands
                                forfeited. <br />• I/We hereby declare that the
                                contents of the form and documents have been
                                fully explained to me/us and that I/we have
                                fully understood the significance of the
                                proposed contract. <br />• I/We acknowledge and
                                agree that, pending receipt of confirmation of
                                this declaration from my/our previous insurers,
                                the “cash-less repair facility” provided by HDFC
                                ERGO General Insurance shall stand suspended.
                                <br />• Section 41- Prohibition of Rebates: No
                                form of inducement shall be made to any person
                                for purchase of insurance policy. Default in
                                complying with the provisions of this section
                                shall be punishable with a fine, which may
                                extend to Rupees Ten lacs. <br />
                                <br />• For more details on risk factors and
                                terms &amp; conditions, please read policy
                                wordings on{" "}
                                <a
                                    href="https://www.hdfcergo.com/"
                                    target="_blank"
                                    className="blue-link-color no-underline hover:underline hover:text-black transition-all"
                                >
                                    www.hdfcergo.com
                                </a>
                                . HDFC Bank is a Corporate Agent of HDFC ERGO
                                General Insurance Company Limited. HDFC Bank
                                does not underwrite the risk nor act as insurer.
                                Reg Office: 1st Floor, HDFC House, 165 - 166
                                Backbay Reclamation, H. T. Parekh Marg,
                                Churchgate, Mumbai – 400 020. Registration
                                Number : 125. <br />
                                <br /> Insurance is the subject matter of
                                solicitation. Govt Taxes &amp; Levies and
                                education cess will be charged extra as per
                                applicable rates. Tax benefits are as per the
                                Income Tax Act, 1961, and are subject to
                                amendments made thereto from time to time Trade
                                Logo displayed above belongs to HDFC LTD and
                                ERGO International AG and used by HDFC ERGO
                                General Insurance Company under license. CIN :
                                U66010MH2002PLC134869.
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    <div className="w-full flex flex-wrap my-8">
                        <button
                            onClick={() => this.props.onclickhandler()}
                            className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue high-amt-apply-submit mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4"
                        >
                            Agree
                        </button>
                        <button
                            onClick={() => this.props.onclickhandlerCancel()}
                            className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default IAgreeTermsInsurence;
